// extracted by mini-css-extract-plugin
export default {"flexibleLink":"SDutJ93W"};